"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Random = void 0;
var Random;
(function (Random) {
    function int() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var min = 0;
        var max = 1;
        if (args.length === 1) {
            max = args[0];
        }
        else if (args.length === 2) {
            min = args[0];
            max = args[1];
        }
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    Random.int = int;
    function pick() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var data = args[0];
        if (args.length === 1) {
            if (Array.isArray(data) || typeof data === "string") {
                // 数组或字符串
                var index = int(data.length - 1);
                return data[index] || null;
            }
            else if (typeof data === "object") {
                // 字典
                var key = pick(Object.keys(data));
                return data[key] || null;
            }
            else {
                return null;
            }
        }
        else {
            var count = args[1];
            var res = [];
            for (var i = 0; i < count; i++) {
                res.push(pick(data));
            }
            return res;
        }
    }
    Random.pick = pick;
    Random.Digits = "0123456789";
    // static Symbols = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~"                   // 32
    Random.Lowers = 'abcdefghijklmnopqrstuvwxyz';
    Random.Uppers = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    Random.Letters = Random.Lowers + Random.Uppers;
    Random.Symbols = "~-_,.?/:;[]{}!@#$%^&*()+=-";
    Random.Characters = Random.Digits + Random.Letters + Random.Symbols;
    // 返回指定长度的随机数字字符串
    function digits(length) {
        return string(length, Random.Digits);
    }
    Random.digits = digits;
    // 返回指定长度的随机英文字符串
    function letters(length) {
        return string(length, Random.Letters);
    }
    Random.letters = letters;
    function characters(length) {
        return string(length, Random.Characters);
    }
    Random.characters = characters;
    function passwords(length, type) {
        switch (type) {
            case "digit":
                return digits(length);
            case "letter":
                return letters(length);
            case "letter-digit":
                return string(length, Random.Letters + Random.Digits);
            case "letter-digit-symbol":
                return characters(length);
            case "lower":
                return string(length, Random.Lowers);
            case "symbol":
                return string(length, Random.Symbols);
            case "upper":
                return string(length, Random.Uppers);
        }
    }
    Random.passwords = passwords;
    // 返回字符来源和长度随机字符串
    function string(length, source) {
        if (source === void 0) { source = Random.Characters; }
        return pick(source, length).join("");
    }
    Random.string = string;
})(Random || (Random = {}));
exports.Random = Random;
//# sourceMappingURL=random.js.map